import { cn } from "@/lib/utils";

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
  xl: 'h-16 w-16',
};

export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <svg
      className={cn(sizeMap[size], 'animate-spin', className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        cx="12" cy="12" r="10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        opacity={0.15}
      />
      {/* `currentColor` statt eines festen Marken-Tons: der Spinner ist eine
          Bedien-Rueckmeldung, kein Marken-Moment, und ein fest verdrahteter
          `hsl(var(--primary))` weiss nicht, auf welcher Flaeche er landet.
          Anlass: in einem Primaer-Knopf (`bg-primary`) massen Bogen und
          Flaeche denselben Ton, Kontrast 1.00:1 -- der Bogen war dort
          buchstaeblich unsichtbar. Seitdem unterscheiden sich Spur und Bogen
          nur noch ueber die Deckkraft (0.15 gegen voll), genau die uebliche
          Bauform eines Spinners. */}
      <circle
        cx="12" cy="12" r="10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="30 70"
      />
    </svg>
  );
}
